<template>
  <div class="mb-4 border-b border-gray-200">
    <ul class="-mb-px flex text-center text-sm font-medium max-md:flex-nowrap max-md:overflow-x-auto md:flex-wrap">
      <slot></slot>
    </ul>
  </div>
</template>
